import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ErrorService } from 'src/app/services/Dossier/error.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Document } from 'src/app/classes/dossier/document';
import { DocumentService } from 'src/app/services/Dossier/document.service';
import { DialogQuestionMessage } from '../../dialogs-question/dialog-question-message.component';
import { MatDialog } from '@angular/material';

@Component({
    selector: 'app-upload-contracts',
    templateUrl: './upload-contracts.component.html',
    styleUrls: ['./upload-contracts.component.scss']
})
export class UploadContractsComponent implements OnInit {
    @Output() isLoadingEvent = new EventEmitter<any>();
    @Output() errorHandlingEvent = new EventEmitter<any>();
    @Output() nextButtonEvent = new EventEmitter<any>();
    @Output() previousButtonEvent = new EventEmitter<any>();
    @Output() forceQuitDelegation = new EventEmitter<any>();
    
    @Input() boolRupture;
    @Input() dossierId;
    @Input() labels;
    @Input() data;

    @Input() reloadEvent: Observable<any>;
    @Input() reloadBoolRupture: Observable<any>;
    
    gifs = [];
    documents = [];
    assignedTypes = [];
    diagnosticTypes = [];
    simulationTypes = [];
    currentTypes = [];
    lackDocuments = [];
    forceFormCheck: boolean = false;
    isLoading: boolean = false;
    
    reloadDossierSubscription: Subscription;
    reloadBoolRuptureSubscription: Subscription;

    numberFilesUploaded: number;
    numberFilesToUpload: number;
    totalFiles: number;
    numberOfValidDocuments: number = 0;

    promises: any = [];
    sizemaxFile: number = 4194304; // 4Mo par défaut
    errorAbbyy: boolean = false;

    constructor(
        private appService: AppService,
        private errorService: ErrorService,
        private httpClient: HttpClient,
        private documentService: DocumentService,
        public dialog: MatDialog,
    ) {

    }

    ngOnInit(): void {
        this.loadGifs("assets/image/cobham-horloge-opti.gif");
        this.loadDocumentTypes();
        this.loadCurrentDocuments();
        this.loadCurrentTypes();
        this.getNumberOfValidDocuments();

        if (this.reloadEvent) {
            this.reloadDossierSubscription = this.reloadEvent.subscribe((dossierId) => {
                this.dossierId = dossierId;
                this.loadCurrentDocuments();
            })
        }
        if (this.reloadBoolRupture) {
            this.reloadBoolRuptureSubscription = this.reloadBoolRupture.subscribe((boolRupture) => {
                this.boolRupture = boolRupture;
                this.loadCurrentTypes();
            })
        }
    }
    
    ngOnDestroy() {
        if (this.reloadEvent) {
            this.reloadDossierSubscription.unsubscribe();
        }
        if (this.reloadBoolRupture) {
            this.reloadBoolRuptureSubscription.unsubscribe();
        }
    }

    getNumberOfValidDocuments() {
        this.numberOfValidDocuments = 0;
        this.documents.map( (document) => {
            if (document.isValid)
                this.numberOfValidDocuments++;
        })
    }

    uploadFile(event) {
        if (event) {
            if (this.promises && this.promises.length > 0) {
                return;
            }
            this.resetBeforeUpload();
            let result = [];
            for (let i = 0; i < event.length; i++) {
                this.numberFilesToUpload = event.length;
                const element = event[i];
        
                if (element.size < this.sizemaxFile) {
                    this.promises.push(
                        this.appService.uploadContractDocument(element, this.dossierId)
                        .toPromise().then(res => {
                            this.numberFilesUploaded++;
                        })
                    )
                } else {
                    result[i].erreur = "Taille du fichier trop élevée";
                    result.splice(i, 1);
                }
            }

            Promise.all(this.promises).then((value) => {
                this.loadCurrentDocuments();
            }).catch((error) => {
                this.resetLoadingParameters();
            })
        }
    }

    loadDocumentTypes() {
        this.httpClient.get('assets/document-delegation.json?v=' + window['cobham_version'])
        .subscribe((res) => {
            if (res["simulation"]) {
                this.simulationTypes = res["simulation"]["types"];
                this.loadTypesByMode("simulation");
            }
            if (res["diagnostic"]) {
                this.diagnosticTypes = res["diagnostic"]["types"];
                this.loadTypesByMode("diagnostic");
            }
            this.loadCurrentTypes();
        })
    }

    loadTypesByMode(mode = "diagnostic") {
        let types = this.diagnosticTypes;
        let label = "libelle";
        if (mode === "simulation") {
            types = this.simulationTypes;
            label = "libelleSimu";
        }

        types.forEach( (type) => {
            let code = type.parametre_code;
            if (code && this.labels && this.labels[code] && this.labels[code][label])
            {
                type.date = this.labels[code][label];
            }
            if (this.data[code]) {
                type.date_value = this.data[code];
            }
        })
    }

    loadCurrentTypes() {
        if (this.boolRupture === "TRUE") {
            this.currentTypes = this.diagnosticTypes;
        } else {
            this.currentTypes = this.simulationTypes;
        }
    }

    loadCurrentDocuments() {
        if (this.dossierId)
            this.documentService.getDocumentsFromDossier(this.dossierId).subscribe((res) => {
                if (res.result.error) {
                    let errorHandlingMessage = this.errorService.errorHandling(res.result);
                    if (errorHandlingMessage) {
                        this.emitEvent('error', errorHandlingMessage);
                    }
                } else {
                    this.totalFiles = res.result.documents.length;
                    this.createDocuments(res.result.documents);
                    this.getNumberOfValidDocuments();
                }
                this.resetLoadingParameters();
            });
    }

    createDocuments(documents) {
        let currentDocuments = [];
        this.documents.map( (document) => {
            currentDocuments.push(document.path);
        })
        documents.map( (document) => {
            if (!currentDocuments.includes(document.file_path))
                this.documents.push(new Document(document));
        })
    }

    resetBeforeUpload() {
        this.emitEvent("loading", true);
        this.numberFilesToUpload = 0;
        this.numberFilesUploaded = 0;
        this.promises = [];
    }

    assignType(typeToAssign) { 
        let index = this.assignedTypes.findIndex( (element) => {
            return typeToAssign.name === element.name;
        });
        if (index >= 0) {
            this.assignedTypes[index].value = typeToAssign.value;
        } else {
            this.assignedTypes.push(typeToAssign)
        }
    }

    resetLoadingParameters() {
        this.promises = [];
        this.forceFormCheck = false;
        this.numberFilesToUpload = 0;
        this.numberFilesUploaded = 0;
        this.emitEvent("loading", false);
    }

    validateContracts() {
        if (this.checkAllContracts()) {
            this.documentService.updateDocumentsFromDossier(this.dossierId, this.documents)
            .subscribe((res) => {
                if (res.result && res.result.success) {
                    this.appService.updateStepDelegation(this.dossierId, 3).subscribe((res) => {
                        if (res.result && res.result.success)
                            this.emitEvent("nextButton", true);
                    })
                }
            });
        } else {
            this.emitEvent("loading", false);
            this.forceFormCheck = true;
            this.askForceSubmit();
        }
    }

    previousScreen() {
        this.emitEvent("previousButton", true);
    }

    checkAllContracts() {
        this.emitEvent("loading", true);
        let isValid = true;
        let mandatoryTypes = [];
        let documentTypes = [];
        this.lackDocuments = [];

        this.currentTypes.forEach(type => {
            if (type.mandatory) {
                mandatoryTypes.push(type.value);
            }
        });
        
        this.documents.forEach(document => {
            if (!document.isValid) {
                isValid = false;
            }
            documentTypes.push(document.type);
        });

        let hasMandatoryTypes = mandatoryTypes.every(type => documentTypes.includes(type));

        if (isValid && hasMandatoryTypes) {
            return true;
        }
        mandatoryTypes.map(type => {
            if (!documentTypes.includes(type)) {
                this.currentTypes.map((model) => {
                    if (type === model.value) {
                        this.lackDocuments.push(model.label);
                    }
                })
            }
        });
        return false;
    }

    changeDocumentState() {
        this.getNumberOfValidDocuments();
    }

    removeDocument(id: number) {
        let toRemove: number;
        this.documents.map( (document, index) => {
            if (document.id === id) {
                toRemove = index;
            }
        })
        this.documents.splice(toRemove, 1);
        this.getNumberOfValidDocuments();
        this.totalFiles--;
    }

    loadGifs(...gifs: any[]) {
        for (var i = 0; i < gifs.length; i++) {
            this.gifs[i] = new Image();
            this.gifs[i].src = gifs[i];
        }
    }

    askForceSubmit() {
        let dialogRef = this.dialog.open(DialogQuestionMessage, {
            width: '50%',
            data: {
                title: "Contrat de travail manquant",
                body: "Si aucun contrat de travail n'a été établi, nous vous invitons " 
                + "à soumettre votre dossier, sinon merci de compléter votre dossier.",
                positiveButton: "Soumettre le dossier",
                negativeButton: "Compléter le dossier",
            }
        })

        dialogRef.afterClosed().subscribe(result => {
            if (result.positive) {
                this.appService.updateStepDelegation(this.dossierId, 3).subscribe((res) => {
                    if (res.result && res.result.success)
                        this.emitEvent("nextButton", true);
                })
            } else {
                this.emitEvent("loading", false);
            }
        });
    }

    emitEvent(event: string, body: any = false) {
        switch(event) {
            case "error":
                this.errorHandlingEvent.emit(body);
                break;
            case "loading":
                this.isLoading = body;
                this.isLoadingEvent.emit(body);
                break;
            case "nextButton":
                this.nextButtonEvent.emit(body);
                break;
            case "previousButton":
                this.previousButtonEvent.emit(body);
                break;
            case "quit":
                this.forceQuitDelegation.emit(body);
                break;
        }
    }
}